import type { Requests } from "../common/request.common";
import type { SubscriptionProductChangeResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const subscriptionProductChange = {
    record(data: typeof Requests.SubscriptionProductChange.Record.Input) {
        return post<typeof data, SubscriptionProductChangeResponseTypes.Record>(
            `/subscription-product-change/record`,
            data,
        );
    },
    create(data: typeof Requests.SubscriptionProductChange.Create.Input) {
        return post<typeof data>("/subscription-product-change/create", data);
    },
    obtain(id: string) {
        return get<SubscriptionProductChangeResponseTypes.Obtain>(
            `/subscription-product-change/obtain/${id}`,
        );
    },
    reject(id: string) {
        return postEmpty(`/subscription-product-change/reject/${id}`);
    },
    approve(id: string) {
        return postEmpty(`/subscription-product-change/approve/${id}`);
    },
};
